import { Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { RouterOutlet, ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { ToastService } from '../../../core/services/toast/toast.service';
import { DelegatedUIErrorI } from '../../../shared/interfaces/delegated-ui-error.interface';
import { ProgramI } from '../interfaces/program.interface';
import { ProgramsApiService } from '../programs-api.service';
import { ProgramsService } from '../programs.service';
import { ProgramsDetailsSideMenuComponent } from './programs-details-side-menu/programs-details-side-menu.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-programs-details',
  imports: [ProgramsDetailsSideMenuComponent, TranslateModule, RouterOutlet],
  templateUrl: './programs-details.component.html',
  styleUrl: './programs-details.component.scss',
})
export class ProgramsDetailsComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  private programsApiService = inject(ProgramsApiService);
  private programsService = inject(ProgramsService);

  private route = inject(ActivatedRoute);
  private location = inject(Location);
  private translateService = inject(TranslateService);
  private toastService = inject(ToastService);
  private cd = inject(ChangeDetectorRef);

  constructor() {}

  programID: string | undefined = undefined;
  selectedProgram: ProgramI | null = null;

  ngOnInit() {
    this.getProgramIDFromRouteParams();
  }

  getProgramIDFromRouteParams() {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((paramMap) => {
        const programID = paramMap.get('programID');
        if (!programID) {
          this.toastService.showError(
            this.translateService.instant('errors.contactTechnicalSupport')
          );
          this.location.back();
        } else {
          this.programID = programID;
          this.fetchProgram();
        }
      });
  }

  fetchProgram() {
    this.programsApiService
      .findOne(this.programID!)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.cd.detectChanges())
      )
      .subscribe({
        next: (findOneResponse) => {
          const { data } = findOneResponse;
          this.selectedProgram = data;
          this.programsService.selectedProgram.set(this.selectedProgram);
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }
}
